import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import AdminApp from "@/admin/AdminApp";
import TriagePage from "@/pages/TriagePage";
import PublicProposalPage from "@/pages/PublicProposalPage";
import PublicAppointmentPage from "@/pages/PublicAppointmentPage";
import PublicInvoicePage from "@/pages/PublicInvoicePage";
import FieldApp from "@/pages/FieldApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/triage" element={<TriagePage />} />
        <Route path="/proposal/:token" element={<PublicProposalPage />} />
        <Route path="/appointment/:token" element={<PublicAppointmentPage />} />
        <Route path="/pay/:token" element={<PublicInvoicePage />} />
        <Route path="/field" element={<FieldApp />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
